module.exports = __webpack_public_path__ + "static/media/main_600.528b9ea3.ico";